"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Splash = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Text_1 = require("../../atoms/Text");
function Splash({ testId, className, graphic, title, subtitle, children, }) {
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('flex', 'flex-col', 'justify-between', 'text-center', 'px-4', className), "data-testid": testId },
        react_1.default.createElement("div", { className: "flex flex-col justify-start" }, graphic),
        react_1.default.createElement(Text_1.Text, { type: Text_1.TextType.DISPLAY_S, className: "mt-10" }, title),
        react_1.default.createElement(Text_1.Text, { type: Text_1.TextType.BODY_M, className: "max-w-md mx-auto mt-3", subdued: true }, subtitle),
        react_1.default.createElement("div", { className: "mt-6" }, children)));
}
exports.Splash = Splash;
//# sourceMappingURL=Splash.js.map